export default __webpack_public_path__ + "3c0f1f9f134b9b6f17de6b56c832ba4b.png";